import {lazy} from 'react'

const TreeEditProfileScreen = lazy(
  () =>
    import(/* webpackChunkName: 'HostEditProfile' */ './TreeEditProfileScreen'),
)

export {TreeEditProfileScreen}
